import { getNavigationUrl } from '../../../utils';
import { Widget } from '../../../apiService';
import Carousel from '../../../Carousel';
import CategoryList from '../../../CategoryList';

const CategoryWidget = ({ widget }: { widget: Widget<'category_carousel'> }) => {
  const {
    display_title,
    configuration: { items, navigation_configuration },
  } = widget;
  const more = getNavigationUrl(navigation_configuration);

  return (
    <Carousel m={0} title={display_title} more={more}>
      <CategoryList items={items.map(({ category }) => category)} />
    </Carousel>
  );
};

export default CategoryWidget;
